var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_2091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.60234 7.2C10.0823 7.2 10.4023 7.52 10.4023 8L10.4023 15.2C10.4023 15.68 10.0823 16 9.60234 16C9.12234 16 8.80234 15.68 8.80234 15.2L8.80234 8C8.80234 7.52 9.12234 7.2 9.60234 7.2Z",
    fill: "#A3FF12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.319 13.92C15.999 13.92 15.759 13.76 15.599 13.52C15.359 13.12 15.519 12.64 15.919 12.4C16.639 12 17.199 11.28 17.439 10.48C17.679 9.68003 17.599 8.80003 17.199 8.08003C16.639 7.04003 15.599 6.40003 14.399 6.40003H13.359C12.959 6.40003 12.639 6.16003 12.559 5.84003C11.759 2.88003 8.71899 1.04003 5.75899 1.84003C4.31899 2.16003 3.11899 3.04003 2.39899 4.32003C1.59899 5.68003 1.43899 7.12003 1.75899 8.64003C1.99899 9.52003 2.39899 10.32 2.95899 10.96C3.27899 11.28 3.19899 11.76 2.87899 12.08C2.55899 12.4 2.07899 12.32 1.75899 12C1.03899 11.12 0.478991 10.16 0.158991 9.04003C-0.321009 7.20003 -0.0810085 5.28003 0.958992 3.60003C1.99899 1.92003 3.51899 0.800028 5.35899 0.320028C9.03899 -0.719972 12.799 1.28003 13.999 4.80003H14.399C16.159 4.80003 17.759 5.76003 18.639 7.28003C19.279 8.40003 19.359 9.68003 19.039 10.96C18.639 12.16 17.839 13.2 16.719 13.84C16.559 13.84 16.479 13.92 16.319 13.92Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.40156 11.2C6.64156 11.2 6.80156 11.28 6.96156 11.44L9.60156 14.08L12.2416 11.44C12.5616 11.12 13.0416 11.12 13.3616 11.44C13.6816 11.76 13.6816 12.24 13.3616 12.56L10.1616 15.76C9.84156 16.08 9.36156 16.08 9.04156 15.76L5.84156 12.56C5.52156 12.24 5.52156 11.76 5.84156 11.44C6.00156 11.28 6.16156 11.2 6.40156 11.2Z",
    fill: "#A3FF12"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_2091"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon_download.ffb7801f1641c430c62c9b5f3d00940d.svg";
export { ForwardRef as ReactComponent };